export const CUSTOMIZE_PACKAGE_LABEL = 'Customize Package';

const hasText = (value: unknown): value is string => typeof value === 'string' && value.trim().length > 0;
const normalizeLabel = (value: unknown) => String(value || '').trim().toLowerCase();

const isCustomPackageLabel = (value: unknown) => {
  const label = normalizeLabel(value);
  return label === 'customize package' || label === 'customized package' || label === 'custom package';
};

export const isCustomizePackage = (value: unknown, pricePackages: Array<{ value: unknown; label?: string }> = []) => {
  const option =
    value && typeof value === 'object' && 'value' in (value as any)
      ? (value as { value: unknown; label?: string })
      : pricePackages.find(item => String(item.value) === String(value));

  const label = option?.label ?? (value && typeof value === 'object' ? (value as any).name : '');
  return isCustomPackageLabel(label);
};

export const normalizeCustomPricePackageName = (value: unknown) => (hasText(value) ? value.trim() : null);

export const getPricePackageName = (item: any, fallback = '-') => {
  const customName = normalizeCustomPricePackageName(item?.customPricePackageName);
  if (customName) return customName;

  const candidates = [
    item?.pricePackageName,
    item?.selectedPricePackage?.label,
    item?.selectedPricePackage?.name,
    item?.pricePackageObj?.label,
    item?.pricePackageObj?.name,
    item?.pricePackage?.label,
    item?.pricePackage?.name,
    item?.packageName,
    item?.pricePackage,
  ];

  const match = candidates.find(hasText);
  return match ? match.trim() : fallback;
};
